var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57143 0C7.04482 0 7.42857 0.396056 7.42857 0.884615V2.35897H12.5714V0.884615C12.5714 0.396056 12.9552 0 13.4286 0C13.902 0 14.2857 0.396056 14.2857 0.884615V2.35897H16.8571C18.5929 2.35897 20 3.81119 20 5.60256V19.7564C20 21.5478 18.5929 23 16.8571 23H3.14286C1.40711 23 0 21.5478 0 19.7564V5.60256C0 3.81118 1.4071 2.35897 3.14286 2.35897H5.71429V0.884615C5.71429 0.396056 6.09804 0 6.57143 0ZM5.71429 4.12821H3.14286C2.35388 4.12821 1.71429 4.7883 1.71429 5.60256V9.4359H18.2857V5.60256C18.2857 4.78829 17.6461 4.12821 16.8571 4.12821H14.2857V5.60256C14.2857 6.09112 13.902 6.48718 13.4286 6.48718C12.9552 6.48718 12.5714 6.09112 12.5714 5.60256V4.12821H7.42857V5.60256C7.42857 6.09112 7.04482 6.48718 6.57143 6.48718C6.09804 6.48718 5.71429 6.09112 5.71429 5.60256V4.12821ZM18.2857 11.2051H1.71429V19.7564C1.71429 20.5707 2.35387 21.2308 3.14286 21.2308H16.8571C17.6462 21.2308 18.2857 20.5707 18.2857 19.7564V11.2051Z",
    fill: "#8566E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.9eae7c036d25d6cbf7e62e5903c85c3d.svg";
export { ForwardRef as ReactComponent };